// src/components/marketing/ContactPage.js
import React from "react";

const ContactPage = () => {
  return (
    <div className="container" style={{ maxWidth: 720, padding: "48px 16px" }}>
      <header style={{ textAlign: "center", marginBottom: 64 }}>
        <h1 style={{ marginBottom: 16, fontSize: "36px" }}>Contact Us</h1>
        <p style={{ color: "var(--muted, #64748b)", fontSize: "18px", lineHeight: "1.6" }}>
          We'd love to hear from you. Whether you have a question, feedback, or
          want to collaborate, here's how to reach us:
        </p>
      </header>

      <section style={{ textAlign: "center" }}>
        <p style={{ fontSize: "16px", marginBottom: "32px" }}>
          Connect with me directly on LinkedIn for any questions, feedback, or collaboration opportunities:{" "}
          <a 
            href="https://www.linkedin.com/in/dcamposliz/" 
            target="_blank" 
            rel="noopener noreferrer"
            style={{ 
              fontSize: "18px",
              fontWeight: "600",
              color: "var(--brand, #59c6c1)"
            }}
          >
            David Aaron Campos
          </a>
        </p>
        <p style={{ 
          color: "var(--muted, #64748b)", 
          fontSize: "16px", 
          fontStyle: "italic",
          marginTop: "32px"
        }}>
          LinkedIn is our primary communication channel as it's more efficient and 
          cost-effective than maintaining email infrastructure.
        </p>
      </section>
    </div>
  );
};

export default ContactPage;
